import React, { useEffect, useState } from "react"
import "./App.css"
import { Footer } from "./components/footer/footer"
import { DownloadContent } from "./components/downloadContent/downloadContent"
import { TrContent } from "./components/trContent/trContent"
import { Header } from "./components/header/header"

function App() {
  const [rongkeTag, setRongkeTag] = useState(true)

  const scaleApp = () => {
    const app = document.getElementById("app")
    if (!app) {
      return
    }
    if (window.innerWidth < 1280) {
      const widthScale = window.innerWidth / app.offsetWidth
      app.style.transform = `scale(${widthScale})`
      app.style.position = "absolute"
      const rootDom = document.getElementById("root")
      if (rootDom) {
        rootDom.style.height = widthScale * 2265 + "px"
      }
    } else {
      app.style.transform = "none"
      app.style.position = "unset"
      document.body.style.height = "auto"
    }
  }

  useEffect(() => {
    scaleApp()
    const eclouldTag = window.location.hostname.startsWith("ecloud.")
    setRongkeTag(!eclouldTag)
    window.addEventListener("load", scaleApp)
    window.addEventListener("resize", scaleApp)
  }, [])

  return (
    <div className="App" id="app">
      <Header rongkeTag={rongkeTag} />
      <DownloadContent rongkeTag={rongkeTag} />
      <TrContent rongkeTag={rongkeTag} />
      <Footer />
    </div>
  )
}

export default App
